<template>
  <div
    class="sn-search"
    :class="{ 'mb-4': !hideDefaultMargin }"
    :style="`width: ${width}`"
  >
    <v-text-field
      v-model="searchTextModel"
      class="sn-body-2"
      data-cy="search-field"
      height="48px"
      hide-details
      :label="placeholderText"
      prepend-inner-icon="$snSearch"
      clearable
      dense
      filled
      flat
      solo
      clear-icon="$snExit"
      :data-pendo="pendo + '-Search'"
      @focus="hidePlaceholder(true)"
      @blur="hidePlaceholder(false)"
      @input="searchDebounce"
      @click:clear="clear"
      @keydown.enter.prevent="handleKeydownEnter($event)"
    />
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  name: 'SnSearch',
  props: {
    value: {
      type: String,
      required: false,
      default: ''
    },
    placeholder: {
      type: String,
      required: false,
      default: 'Search'
    },
    width: {
      type: String,
      required: false,
      default: '285px'
    },
    hideDefaultMargin: {
      type: Boolean,
      required: false,
      default: false
    },
    pendo: {
      type: String,
      default: null,
      required: false
    }
  },
  data () {
    return {
      placeholderText: this.placeholder,
      searchText: '',
      cleared: false
    }
  },
  computed: {
    searchTextModel: {
      get () { return this.searchText },
      set (value) {
        this.$emit('input', value)
        this.searchText = value
      }
    }
  },
  watch: {
    value () {
      this.searchText = this.value
    },
    placeholder () {
      this.placeholderText = this.placeholder
    }
  },
  created () {
    this.searchText = this.value
    this.searchDebounce = debounce(() => {
      if (!this.cleared) {
        this.$emit('search', this.searchTextModel)
      }
      this.cleared = false
    }, 550)
  },
  methods: {
    clear () {
      this.searchText = null
      this.cleared = true
      this.$emit('search', this.searchTextModel)
    },
    hidePlaceholder (hide) {
      this.placeholderText = hide ? '' : this.placeholder
    },
    handleKeydownEnter (event) {
      this.searchDebounce.cancel()
      this.$emit('search', event.target.value)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~/assets/css/snui/index.scss';

.sn-search ::v-deep .v-input {
  &__icon svg {
    color: $sn-primary-01 !important;
    -webkit-appearance: none;
  }

  &__slot {
    background: $sn-gray-01 !important;
    border: 1px solid white !important;
    border-radius: 24px !important;

    label {
      font-family: $font-family-primary;
      font-size: 15px;
      font-weight: $font-weight-regular;
      line-height: 26px;
      color: $sn-primary-01;
      height: auto;
    }

    input {
      caret-color: $sn-primary-03;
      color: $sn-primary-03;
      padding-top: 2px;
      height: auto;
    }

    &:hover {
      border-color: $sn-primary-03 !important;
    }

    &:focus-within {
      border-color: $sn-brand !important;
    }
  }
}
</style>
